export class AsyncImportStatus {
    constructor(status: string, description: string, info: Info) {
        this.description = description;
        this.status = ImportStatus[status];
        this.info =info;
    }
    status: ImportStatus;
    description: string;
    info: Info
    startedAt:string
    finishAt: string
    createdAt: string

    getStatusDescription():string{
        return this.status == ImportStatus.FAILED ? `Importação Finalizada com Erros` :
        this.status == ImportStatus.PROCESSING ? 'Importação Sendo Processada' :
        this.status == ImportStatus.WAITING ? 'Importação Aguardando Na Fila' :
        this.status == ImportStatus.PROCESSED ? 'Importação Finalizada' : '??'
    }

    isFinished():boolean{
        return [ImportStatus.PROCESSED, ImportStatus.FAILED, ImportStatus.PARTIAL].includes(this.status)
    }
    statusLabel():string{
        return this.status == ImportStatus.FAILED ? `Falha` :
        this.status == ImportStatus.PROCESSING ? 'Processando' :
        this.status == ImportStatus.WAITING ? 'Aguardando' :
        this.status == ImportStatus.PROCESSED ? 'Processado' : '??'
    }
}
export class Info {
    constructor(totalUpdated: number,
        totalCreated: number,
        totalRemoved: number,
        totalFailed: number,
        exceptionLog: string,
        infoLog:boolean) {
        this.totalUpdated = totalUpdated;
        this.totalCreated = totalCreated;
        this.totalRemoved = totalRemoved;
        this.totalFailed = totalFailed;
        this.exceptionLog = exceptionLog
        this.infoLog = infoLog
    }
    totalUpdated: number;
    totalCreated: number;
    totalRemoved: number;
    totalFailed: number;
    exceptionLog: string;
    infoLog:boolean;
    errors!: string | null
}
export enum ImportStatus {
    WAITING,
    PROCESSING,
    PROCESSED,
    FAILED,
    PARTIAL
}